import {$body} from "./globals";
export const CisModal = (function () {
    let visibleCount = 0;
    let lastId = 0;
    const html = $('html');
    let canClose = true;

    return function (size, options) {
        var _this = this;
        this.id = lastId + 1;
        lastId++;
        this.visible = false;
        this.hasClickOutsideEvent = false;
        this.options = {
            size: {
                normal: '',
                wider: 'c-modal__content-wider',
                wide: 'c-modal__content-wide',
            },
            additionalClasses: '',
            additionalModalClasses: '',
            additionalStylesheet: '',
            closeOnClickOutside: true,
            additionalCloseClass: ''
        };
        if (typeof options !== 'undefined') {
            this.options = $.extend({}, _this.options, options);
        }
        if (typeof size === 'undefined' || (typeof size === 'object')) {
            size = 'normal';
        }
        this.size = size;
        this.element = $(document.createElement('div'));
        this.element.addClass('c-modal js-modal');
        this.element.append('<div class="c-modal__content '+ _this.options.additionalModalClasses +' '+ _this.options.size[size] +'">' +
            '<div class="c-modal__close '+ _this.options.additionalCloseClass +'" data-modal-close></div>' +
            '<h4 class="c-modal__head u-mb-8">title</h4>' +
            '<div class="c-modal__body '+_this.options.additionalClasses+'">body</div>' +
            '</div>');

        if (_this.options.closeOnClickOutside && !_this.hasClickOutsideEvent) {
            _this.hasClickOutsideEvent = true;
            $body.on('click keyup', function (e) {
                if ((e.type === 'keyup' && e.key === 'Escape') || (e.type === 'click' && !$(e.target).closest('.c-modal__content,.select2-search').length) && _this.visible) {
                    e.stopPropagation();
                    _this.close();
                }
            });
        }

        this.open = function ($title, $innerBody, resize = false) {
            if (!this.visible) {
                this.element.removeClass("is-open");
            }
            if (resize) {
                if (typeof _this.options.size[resize] != "undefined") {
                    _this.resize = resize;
                    const content = this.element.find('.c-modal__content');
                    content.removeClass(_this.options.size[_this.size]);
                    content.addClass(_this.options.size[_this.resize]);
                }
            }
            if (!this.visible) {
                visibleCount++;
                this.visible = true;
            }
            this.element.find('.c-modal__head').html($title);
            const elementBody = this.element.find('.c-modal__body');
            elementBody.html($innerBody);
            if (_this.options.additionalStylesheet && !$('#cmodalstyle' + _this.id).length) {
                $innerBody.append('<link rel="stylesheet" id="cmodalstyle' + _this.id + '" href="' + _this.options.additionalStylesheet + '">');
            }
            html.addClass("has-modal-open");
            this.element.find('[data-modal-close]').on("click", function (e) {
                e.preventDefault();
                _this.close();
            });
            $body.append(this.element);
            //body.css("padding-right", this.getScrollbarWidth());
            //console.log(this.element);
            setTimeout(function () {
                _this.element.addClass("is-open");
            }, 10);
            setTimeout(function () {
                if (typeof tinymce !== "undefined") {
                    try {
                        tinymce.remove();
                    } catch (e) {
                        //asi nic
                    }
                    if (typeof InicializaceTinymce === "function") {
                        InicializaceTinymce();
                    }
                }
                //nevim proc, ale umira to tady obcas...
            }, 1000);
            const openEvent = $.Event('cis.modal.open', {_this});
            _this.element.trigger(openEvent);
        };

        this.close = function () {
            if (canClose) {
                if (this.visible) {
                    visibleCount--;
                    this.visible = false;
                }
                this.element.removeClass("is-open");
                const hideEvent = $.Event('cis.modal.hide', {_this});
                _this.element.trigger(hideEvent);
                //nevim proc, ale umira to tady obcas...
                if (typeof tinymce !== "undefined") {
                    try {
                        tinymce.remove();
                    } catch (e) {
                        //asi nic
                    }
                }
                this.destroy();
            } else {
                const closeEvent = $.Event('cis.modal.closePrevent', {_this});
                _this.element.trigger(closeEvent);
            }
        };

        this.destroy = function () {
            this.element.on('transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd', function () {
                $(this).remove();
                if (typeof _this.resize != "undefined") {
                    const content = _this.element.find('.c-modal__content');
                    content.removeClass(_this.options.size[_this.resize]);
                    content.addClass(_this.options.size[_this.size]);
                    delete _this.resize;
                }
                if (visibleCount === 0) {
                    if (_this.options.additionalStylesheet) {
                        $('#cmodalstyle' + _this.id).remove();
                    }
                    html.removeClass("has-modal-open");
                    //body.css("padding-right", 0);
                }
                const closeEvent = $.Event('cis.modal.close', {_this});
                _this.element.trigger(closeEvent);
                if (typeof InicializaceTinymce === "function") {
                    InicializaceTinymce();
                }
            });
        };

        this.getScrollbarWidth = function () {
            // Creating invisible container
            const outer = document.createElement("div");
            outer.style.visibility = "hidden";
            outer.style.overflow = "scroll"; // forcing scrollbar to appear
            outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps
            document.body.appendChild(outer);

            // Creating inner element and placing it in the container
            const inner = document.createElement("div");
            outer.appendChild(inner);

            // Calculating difference between container's full width and the child width
            const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);

            // Removing temporary elements from the DOM
            outer.parentNode.removeChild(outer);

            return scrollbarWidth;
        };

        this.preventClose = function (val) {
            canClose = typeof val == "undefined" ? false : !val;
        }
    };
})();

export const cModal = new CisModal('wider');
